import React, { useState } from 'react';

function DataSourceEditor(props) {
  const { dataSource, onChange, onAutoMap } = props;
  const [jsonInput, setJsonInput] = useState(JSON.stringify(dataSource.data || [], null, 2));

  const setType = (type) => {
    if (type === 'api') {
      onChange({
        type: 'api',
        url: '',
        method: 'GET',
        data: [], // Ensure data array exists
      });
    } else {
      onChange({
        type: 'custom',
        data: [],
      });
      setJsonInput('[]');
    }
  };

  const handleJsonChange = (e) => {
    const value = e.target.value;
    setJsonInput(value);
    try {
      const parsed = JSON.parse(value);
      onChange({ ...dataSource, data: parsed });
    } catch {
      // Don't update state while parsing
    }
  };

  const handleCsvUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split('\n');
      const headers = lines[0].split(',').map(h => h.trim());
      const data = lines.slice(1).filter(l => l.trim()).map(line => {
        const values = line.split(',').map(v => v.trim());
        const obj = {};
        headers.forEach((header, i) => {
          const val = values[i];
          obj[header] = isNaN(val) ? val : Number(val);
        });
        return obj;
      });
      onChange({ ...dataSource, type: 'custom', data });
      setJsonInput(JSON.stringify(data, null, 2));
    };
    reader.readAsText(file);
  };

  React.useEffect(() => {
    if (dataSource.type === 'custom' && dataSource.data) {
      setJsonInput(JSON.stringify(dataSource.data, null, 2));
    }
  }, [dataSource]);

  return (
    <div className="sidebar-panel">
      <h3>Data Source</h3>
      <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
          <input
            type="radio"
            checked={dataSource.type === 'api'}
            onChange={() => setType('api')}
          />
          API
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
          <input
            type="radio"
            checked={dataSource.type === 'custom'}
            onChange={() => setType('custom')}
          />
          Manual/CSV
        </label>
      </div>

      {dataSource.type === 'api' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label className="form-label">API URL</label>
          <input
            className="form-control"
            type="text"
            value={dataSource.url || ''}
            onChange={(e) => onChange({ ...dataSource, url: e.target.value })}
            placeholder="https://api.example.com/data"
          />

          <div style={{ display: 'flex', gap: '8px' }}>
            <div style={{ flex: 1 }}>
              <label className="form-label">Method</label>
              <select
                className="form-control"
                value={dataSource.method || 'GET'}
                onChange={(e) => onChange({ ...dataSource, method: e.target.value })}
              >
                <option>GET</option>
                <option>POST</option>
              </select>
            </div>
            <div style={{ flex: 2 }}>
              <label className="form-label">Auth Type</label>
              <select
                className="form-control"
                value={dataSource.authType || 'none'}
                onChange={(e) => onChange({ ...dataSource, authType: e.target.value })}
              >
                <option value="none">No Auth</option>
                <option value="bearer">Bearer Token</option>
                <option value="basic">Basic Auth</option>
              </select>
            </div>
          </div>

          {dataSource.authType === 'bearer' && (
            <div>
              <label className="form-label">Token</label>
              <input
                className="form-control"
                type="password"
                value={dataSource.token || ''}
                onChange={(e) => onChange({ ...dataSource, token: e.target.value })}
                placeholder="Bearer token..."
              />
            </div>
          )}

          {dataSource.authType === 'basic' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{ flex: 1 }}>
                <label className="form-label">User</label>
                <input
                  className="form-control"
                  type="text"
                  value={dataSource.username || ''}
                  onChange={(e) => onChange({ ...dataSource, username: e.target.value })}
                  placeholder="Username"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label className="form-label">Pass</label>
                <input
                  className="form-control"
                  type="password"
                  value={dataSource.password || ''}
                  onChange={(e) => onChange({ ...dataSource, password: e.target.value })}
                  placeholder="Password"
                />
              </div>
            </div>
          )}

          <button
            className="btn btn--primary btn--sm"
            style={{ marginTop: '8px' }}
            onClick={() => onAutoMap('fetch')}
          >
            🔄 Fetch & Map Now
          </button>
        </div>
      )}

      {dataSource.type === 'custom' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label className="form-label">Upload CSV</label>
            <input
              type="file"
              accept=".csv"
              onChange={handleCsvUpload}
              className="form-control"
              style={{ fontSize: '11px' }}
            />
          </div>

          <div>
            <label className="form-label">JSON Data</label>
            <textarea
              className="form-control"
              value={jsonInput}
              onChange={handleJsonChange}
              placeholder='[{"id": "element_1", "value": 10}]'
              style={{
                fontFamily: 'var(--font-family-mono)',
                fontSize: '11px',
                minHeight: '120px',
              }}
            />
          </div>

          <button
            className="btn btn--primary btn--sm"
            onClick={onAutoMap}
            title="Automatically map data IDs to SVG element IDs"
          >
            ⚡ Auto-map Data to Elements
          </button>
        </div>
      )}
    </div>
  );
}

export default DataSourceEditor;
